import * as React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import FluentUiIcon from "../../../../../../../assets/fluent-ui-icon";
import { ArchiveIcon } from "../../../../../../../assets/icons";
import "../../../../../../tasks/scenes/tasks-comments/shared-modal-header.scss";

export const MyCommandCell = (props) => {
  const { dataItem } = props;
  const inEdit = dataItem[props.editField];
  const isNewItem = dataItem.Id === null;
  const [visible, setVisible] = React.useState(false);
  const onDeleteData = () => {
    props.remove(props.dataItem);
    setVisible(!visible);
  };
  const toggleDialog = () => {
    setVisible(!visible);
  };
  return (
    <td className="k-command-cell">
      <div className="actions">
        <div
          onClick={() =>
            isNewItem
              ? props.add(dataItem)
              : inEdit
              ? props.update(dataItem)
              : props.edit(dataItem)
          }
        >
          <FluentUiIcon
            name={inEdit ? "SaveRegular" : "EditRegular"}
            color={"#0e75bb"}
            size={20}
          />
        </div>
        <div
          onClick={() =>
            isNewItem
              ? props.discard(dataItem)
              : inEdit
              ? props.cancel(dataItem)
              : toggleDialog()
          }
        >
          <FluentUiIcon
            name={inEdit ? "DismissRegular" : "DeleteRegular"}
            color={"#0e75bb"}
            size={20}
          />
        </div>
      </div>
      {visible && (
        <Modal
          show={true}
          onHide={toggleDialog}
          className="new-project-status-change-popup tasks-actions-popup"
        >
          <Modal.Header className="header-popup" closeButton>
            <Modal.Title className="actions-title">
              Delete Condition
            </Modal.Title>
          </Modal.Header>
          <div className="select-member-divider-line"></div>
          <Modal.Body>
            <img className="complete-icon" src={ArchiveIcon} alt="Complete" />
            <h3 className="actions-task-name-center">
              Are you sure you want to delete this condition?
            </h3>
            <div
              className="d-flex justify-content-between"
              style={{ marginTop: "32px" }}
            >
              <button className="tertiary-btn" onClick={toggleDialog}>
                No, Go Back
              </button>
              <button className="primary-btn" onClick={onDeleteData}>
                Yes, Delete Condition
              </button>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </td>
  );
};

MyCommandCell.propTypes = {
  dataItem: PropTypes.object,
  editField: PropTypes.string,
  remove: PropTypes.func,
  add: PropTypes.func,
  update: PropTypes.func,
  edit: PropTypes.func,
  discard: PropTypes.func,
  cancel: PropTypes.func,
};

export const CommandCell = (props) => {
  const { edit, remove, add, discard, update, cancel, editField } = props;
  return (
    <MyCommandCell
      {...props}
      edit={edit}
      remove={remove}
      add={add}
      discard={discard}
      update={update}
      cancel={cancel}
      editField={editField}
    />
  );
};
CommandCell.propTypes = {
  edit: PropTypes.func,
  remove: PropTypes.func,
  add: PropTypes.func,
  discard: PropTypes.func,
  update: PropTypes.func,
  cancel: PropTypes.func,
  editField: PropTypes.string,
};